// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"005041ac","773":"48281775","787":"bc88ca4f","815":"aec31bc6"}[chunkId] + ".chunk.js";
};